import { Box, SxProps } from '@mui/material';
import { useImagePreview } from 'src/hooks/use-image-preview';
import Iconify from 'src/components/iconify';
import ClickableImage from './clickable-image';
import { ImagePreviewDialog } from './image-preview-dialog';

type Props = {
  src: string;
  alt?: string;
  sx?: SxProps;
  previewSize?: { width: number; height: number };
  showPreview?: boolean;
  disableRightClick?: boolean;
  fileName?: string;
};

export default function ImageWithPreview({
  src,
  alt = '',
  sx,
  previewSize = { width: 150, height: 150 },
  showPreview = true,
  disableRightClick = false,
  fileName,
}: Props) {
  const imagePreview = useImagePreview();

  const borderSx = {
    border: 1,
    borderColor: 'divider',
    borderRadius: 1,
    ...sx,
  };

  const containerSx = {
    position: 'relative',
    display: 'inline-block',
    cursor: showPreview ? 'pointer' : 'default',
    '&:hover .hover-overlay': {
      opacity: 1,
    },
  };

  const overlaySx = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: 1,
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
  };

  if (!showPreview) {
    return (
      <ClickableImage
        src={src}
        alt={alt}
        sx={borderSx}
        previewSize={previewSize}
        disableRightClick={disableRightClick}
      />
    );
  }

  return (
    <>
      <Box sx={containerSx} onClick={() => imagePreview.handleImageClick(src)}>
        <ClickableImage
          src={src}
          alt={alt}
          sx={borderSx}
          previewSize={previewSize}
          disableRightClick={disableRightClick}
        />
        <Box className="hover-overlay" sx={overlaySx}>
          <Iconify icon="mdi:eye" width={32} sx={{ color: 'white' }} />
        </Box>
      </Box>

      <ImagePreviewDialog
        open={imagePreview.isOpen}
        onClose={imagePreview.handleClose}
        imageUrl={imagePreview.imageUrl}
        disableRightClick={disableRightClick}
        fileName={fileName}
      />
    </>
  );
}
